import { FC, ReactNode } from 'react'

export const Group: FC<{ children: ReactNode; name: string }> = ({
  children,
}) => children
